import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const chunkReloadGuardKey = "workerstation:chunk-reload-at";
export const ChunkRecoveryClock = Schema.Int;
export const ChunkRecoveryGuard = Schema.NullOr(Schema.String);
export const ChunkRecoveryResult = Schema.Literals(["ReloadRequested", "Guarded", "Closed"]);
export type ChunkRecoveryResult = typeof ChunkRecoveryResult.Type;
export class ChunkRecoveryIoFailure extends privateDependencyFailure<ChunkRecoveryIoFailure>()("ChunkRecoveryIoFailure", "chunk recovery") {}
export const chunkRecoveryIoFailure = (cause: unknown) => new ChunkRecoveryIoFailure({ cause: Redacted.make(cause) });
export const ChunkRecoveryNotice = Schema.Union([
  Schema.TaggedStruct("PreloadError", {}),
  Schema.TaggedStruct("ListenerFailure", { error: ChunkRecoveryIoFailure })
]);
export type ChunkRecoveryNotice = typeof ChunkRecoveryNotice.Type;

// Retain the original numeric guard, including malformed stored strings and a
// clock moving backwards. Only the browser I/O boundary supplies these values.
export function chunkReloadGuarded(value: string | null, now: number): boolean {
  return now - Number(value ?? 0) < 15_000;
}
